module.exports = __webpack_public_path__ + "img/5868bbd37b7e4031b28b6a1fdbc52640-1024.4e2ce23d.jpg";